var Config = {
  LIMIT: 10,
  PERSIST_SECRET_KEY: "MCAP_REDUX_PERSIST_STORE_KEY",
  // create-react-app inlines process.env.REACT_APP_* at BUILD time, so this
  // is fixed the moment the image is built and cannot be changed by
  // restarting the container — changing which API this app talks to means
  // rebuilding. docker-compose.staging.yml passes it through as a build arg,
  // same pattern Neo-Admin-web uses for its own ADMIN_API_URL.
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "STAGING",
  ENVIRONMENTS: {
    LOCAL: {
      API_URL: "http://localhost:8080/v1",
    },
    // APP_API_URL is a placeholder substituted at deploy time by the
    // pipeline's replace-env-vars step, not a literal value.
    DEVELOPMENT: {
      API_URL: "APP_API_URL",
    },
    STAGING: {
      API_URL: process.env.REACT_APP_API_URL || "",
    },
    PRODUCTION: {
      API_URL: process.env.REACT_APP_API_URL || "",
    },
  },
};

Config.env = () => {
  return Config.ENVIRONMENTS[Config.ENVIRONMENT];
};

export default Config;
